import GlobalHierarchyModel from "../../models/master-data-management/global-hierarchy/global-hierarchy.model";
import TreeInputComponent from "../treeview/tree-input.component";

export default function CodemasterCategorySearchTree() {
    let items = [];

    const getTreeItems = (hierarchyType, fromLevel, toLevel) => {
        GlobalHierarchyModel.getHierarchyTree(hierarchyType, fromLevel, toLevel)
            .then((result) => {
                if(result) {
                    items = result;
                }
            });
    };

    return {
        oninit: ({ attrs: { category, fromLevel, toLevel } }) => {
            getTreeItems(category, fromLevel, toLevel);
        },
        view: ({ attrs: { 
            id, 
            required, 
            disabled, 
            icon, 
            title, 
            selectedItems,
            isLevel1Expanded, 
            onChange } 
        }) => m(TreeInputComponent, {
            id,
            title,
            required,
            disabled,
            icon,
            items,
            selectedItems,
            isLevel1Expanded,
            onChange
        })
    }
}